import { Link } from 'react-router-dom';
import { navItems, siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-300/30">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 flex items-center justify-center font-heading font-bold text-lg">
                月
              </span>
              <span className="font-heading font-semibold text-foreground-950 text-lg">
                {siteInfo.brand}
                <span className="text-foreground-500 text-sm ml-1">{siteInfo.tagline}</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-500 max-w-sm">
              专注《无颜之月》剧集内容展示，提供剧情介绍、剧集更新与相关影视推荐，方便观众了解剧情走势与同风格作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm tracking-widest text-foreground-300 mb-4 uppercase">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              {navItems.map((item) => (
                <li key={item.key}>
                  <Link
                    to={item.path}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm tracking-widest text-foreground-300 mb-4 uppercase">
              联系我们
            </h4>
            <p className="text-sm text-foreground-500 mb-2">意见反馈与内容合作：</p>
            <a
              href={`mailto:${siteInfo.email}`}
              className="inline-flex items-center gap-2 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line" />
              {siteInfo.email}
            </a>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-500">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-500">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-500">
                <i className="ri-mail-send-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-300/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400 text-center sm:text-left">
            © 2026 {siteInfo.brand}{siteInfo.tagline} · 保留所有权利
          </p>
          <p className="text-xs text-foreground-400 text-center sm:text-right">
            本站为影视资讯演示站点，内容与角色均为虚构，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}